import React from "react";
import ReactDOM from "react-dom/client";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/custom.css";
import reportWebVitals from "./reportWebVitals";
import Routes from "./routes";
import history from "./managers/history";
import { store } from "./store";
import { Provider as ChakraProvider } from "./components/ui/provider";
import {
  VideoTutorialProvider,
  useVideoTutorial
} from "./contexts/VideoTutorialContext";
import VideoTutorial from "./common/components/VideoTutorial/VideoTutorial";
import TutorialFab from "./common/components/VideoTutorial/TutorialFab";

const GlobalVideoTutorial = () => {
  const { showVideo, closeVideo } = useVideoTutorial();

  if (!showVideo) return null;

  return <VideoTutorial videoId="NclTzkZ7s28" onClose={closeVideo} />;
};

const WebApp = () => {
  return (
    <ChakraProvider>
      <HistoryRouter history={history}>
        <ReduxProvider store={store}>
          <VideoTutorialProvider>
            <Routes />
            <GlobalVideoTutorial />
            <TutorialFab />
            <ToastContainer position="top-center" />
          </VideoTutorialProvider>
        </ReduxProvider>
      </HistoryRouter>
    </ChakraProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<WebApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
